import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__sign-in",
  "use": "icon__sign-in-usage",
  "viewBox": "0 0 18 19",
  "content": "<symbol viewBox=\"0 0 18 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__sign-in\"><title>Shape</title><path d=\"M9 0C6.238 0 4 2.273 4 5.077v.846C4 8.727 6.238 11 9 11s5-2.273 5-5.077v-.846C14 2.273 11.762 0 9 0zm0 13C5.72 13 1.515 14.857.305 16.506-.442 17.525.27 19 1.496 19h15.008c1.226 0 1.938-1.475 1.19-2.494C16.484 14.858 12.277 13 9 13z\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol